var map = {
	"./American.png": 89,
	"./Australian.png": 90,
	"./Austrian.png": 91,
	"./Belgian.png": 92,
	"./Brazilian.png": 93,
	"./British.png": 94,
	"./Canadian.png": 95,
	"./Danish.png": 96,
	"./Dutch.png": 97,
	"./Finnish.png": 98,
	"./French.png": 99,
	"./German.png": 100,
	"./Indian.png": 101,
	"./Indonesian.png": 102,
	"./Italian.png": 103,
	"./Japanese.png": 104,
	"./Mexican.png": 105,
	"./Monegasque.png": 106,
	"./New Zealander.png": 107,
	"./Polish.png": 108,
	"./Russian.png": 109,
	"./Spanish.png": 110,
	"./Swedish.png": 111,
	"./Swiss.png": 112,
	"./Venezuelan.png": 113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;